/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminSessionDto,
  AdminUserDto,
  AdminUsersDeleteAdminUsersIdGuidSessions200,
  AdminUsersGetAdminUsersParams,
  CreateAdminUserRequest,
  CreateAdminUserResult,
  HttpValidationProblemDetails,
  PagedResultOfAdminUserDto,
  UpdateAdminUserRequest,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const adminUsersGetAdminUsers = (
  params?: AdminUsersGetAdminUsersParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfAdminUserDto>(
    { url: `/admin/users`, method: 'GET', params, signal },
    options,
  );
};

export const getAdminUsersGetAdminUsersQueryKey = (params?: AdminUsersGetAdminUsersParams) => {
  return [`/admin/users`, ...(params ? [params] : [])] as const;
};

export const getAdminUsersGetAdminUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsers>>,
  TError = unknown,
>(
  params?: AdminUsersGetAdminUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetAdminUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUsersGetAdminUsers>>> = ({
    signal,
  }) => adminUsersGetAdminUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminUsersGetAdminUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetAdminUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersGetAdminUsers>>
>;
export type AdminUsersGetAdminUsersQueryError = unknown;

export function useAdminUsersGetAdminUsers<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsers>>,
  TError = unknown,
>(
  params: undefined | AdminUsersGetAdminUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersGetAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof adminUsersGetAdminUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetAdminUsers<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsers>>,
  TError = unknown,
>(
  params?: AdminUsersGetAdminUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersGetAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof adminUsersGetAdminUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetAdminUsers<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsers>>,
  TError = unknown,
>(
  params?: AdminUsersGetAdminUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminUsersGetAdminUsers<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsers>>,
  TError = unknown,
>(
  params?: AdminUsersGetAdminUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminUsersGetAdminUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Invite a new admin user; returns a temporary password ONCE.
 */
export const adminUsersPostAdminUsers = (
  createAdminUserRequest: CreateAdminUserRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<CreateAdminUserResult>(
    {
      url: `/admin/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAdminUserRequest,
      signal,
    },
    options,
  );
};

export const getAdminUsersPostAdminUsersMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersPostAdminUsers>>,
    TError,
    { data: CreateAdminUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersPostAdminUsers>>,
  TError,
  { data: CreateAdminUserRequest },
  TContext
> => {
  const mutationKey = ['adminUsersPostAdminUsers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersPostAdminUsers>>,
    { data: CreateAdminUserRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminUsersPostAdminUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersPostAdminUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersPostAdminUsers>>
>;
export type AdminUsersPostAdminUsersMutationBody = CreateAdminUserRequest;
export type AdminUsersPostAdminUsersMutationError = HttpValidationProblemDetails;

/**
 * @summary Invite a new admin user; returns a temporary password ONCE.
 */
export const useAdminUsersPostAdminUsers = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUsersPostAdminUsers>>,
      TError,
      { data: CreateAdminUserRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersPostAdminUsers>>,
  TError,
  { data: CreateAdminUserRequest },
  TContext
> => {
  const mutationOptions = getAdminUsersPostAdminUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminUsersGetAdminUsersIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<AdminUserDto>({ url: `/admin/users/${id}`, method: 'GET', signal }, options);
};

export const getAdminUsersGetAdminUsersIdGuidQueryKey = (id?: string) => {
  return [`/admin/users/${id}`] as const;
};

export const getAdminUsersGetAdminUsersIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetAdminUsersIdGuidQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>> = ({
    signal,
  }) => adminUsersGetAdminUsersIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetAdminUsersIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>
>;
export type AdminUsersGetAdminUsersIdGuidQueryError = unknown;

export function useAdminUsersGetAdminUsersIdGuid<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetAdminUsersIdGuid<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetAdminUsersIdGuid<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminUsersGetAdminUsersIdGuid<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuid>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminUsersGetAdminUsersIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminUsersPutAdminUsersIdGuid = (
  id: string,
  updateAdminUserRequest: UpdateAdminUserRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<AdminUserDto>(
    {
      url: `/admin/users/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAdminUserRequest,
    },
    options,
  );
};

export const getAdminUsersPutAdminUsersIdGuidMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersPutAdminUsersIdGuid>>,
    TError,
    { id: string; data: UpdateAdminUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersPutAdminUsersIdGuid>>,
  TError,
  { id: string; data: UpdateAdminUserRequest },
  TContext
> => {
  const mutationKey = ['adminUsersPutAdminUsersIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersPutAdminUsersIdGuid>>,
    { id: string; data: UpdateAdminUserRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminUsersPutAdminUsersIdGuid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersPutAdminUsersIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersPutAdminUsersIdGuid>>
>;
export type AdminUsersPutAdminUsersIdGuidMutationBody = UpdateAdminUserRequest;
export type AdminUsersPutAdminUsersIdGuidMutationError = HttpValidationProblemDetails;

export const useAdminUsersPutAdminUsersIdGuid = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUsersPutAdminUsersIdGuid>>,
      TError,
      { id: string; data: UpdateAdminUserRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersPutAdminUsersIdGuid>>,
  TError,
  { id: string; data: UpdateAdminUserRequest },
  TContext
> => {
  const mutationOptions = getAdminUsersPutAdminUsersIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminUsersDeleteAdminUsersIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<void>({ url: `/admin/users/${id}`, method: 'DELETE' }, options);
};

export const getAdminUsersDeleteAdminUsersIdGuidMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuid>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminUsersDeleteAdminUsersIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuid>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminUsersDeleteAdminUsersIdGuid(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersDeleteAdminUsersIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuid>>
>;

export type AdminUsersDeleteAdminUsersIdGuidMutationError = unknown;

export const useAdminUsersDeleteAdminUsersIdGuid = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuid>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminUsersDeleteAdminUsersIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminUsersPostAdminUsersIdGuidDeactivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<AdminUserDto>(
    { url: `/admin/users/${id}/deactivate`, method: 'POST', signal },
    options,
  );
};

export const getAdminUsersPostAdminUsersIdGuidDeactivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidDeactivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidDeactivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminUsersPostAdminUsersIdGuidDeactivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidDeactivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminUsersPostAdminUsersIdGuidDeactivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersPostAdminUsersIdGuidDeactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidDeactivate>>
>;

export type AdminUsersPostAdminUsersIdGuidDeactivateMutationError = unknown;

export const useAdminUsersPostAdminUsersIdGuidDeactivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidDeactivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidDeactivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminUsersPostAdminUsersIdGuidDeactivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminUsersPostAdminUsersIdGuidActivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<AdminUserDto>(
    { url: `/admin/users/${id}/activate`, method: 'POST', signal },
    options,
  );
};

export const getAdminUsersPostAdminUsersIdGuidActivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidActivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminUsersPostAdminUsersIdGuidActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidActivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminUsersPostAdminUsersIdGuidActivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersPostAdminUsersIdGuidActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidActivate>>
>;

export type AdminUsersPostAdminUsersIdGuidActivateMutationError = unknown;

export const useAdminUsersPostAdminUsersIdGuidActivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidActivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersPostAdminUsersIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminUsersPostAdminUsersIdGuidActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminUsersGetAdminUsersIdGuidSessions = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<AdminSessionDto[]>(
    { url: `/admin/users/${id}/sessions`, method: 'GET', signal },
    options,
  );
};

export const getAdminUsersGetAdminUsersIdGuidSessionsQueryKey = (id?: string) => {
  return [`/admin/users/${id}/sessions`] as const;
};

export const getAdminUsersGetAdminUsersIdGuidSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetAdminUsersIdGuidSessionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>
  > = ({ signal }) => adminUsersGetAdminUsersIdGuidSessions(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetAdminUsersIdGuidSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>
>;
export type AdminUsersGetAdminUsersIdGuidSessionsQueryError = unknown;

export function useAdminUsersGetAdminUsersIdGuidSessions<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
          TError,
          Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetAdminUsersIdGuidSessions<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
          TError,
          Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetAdminUsersIdGuidSessions<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminUsersGetAdminUsersIdGuidSessions<
  TData = Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminUsersGetAdminUsersIdGuidSessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminUsersGetAdminUsersIdGuidSessionsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminUsersDeleteAdminUsersIdGuidSessions = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<AdminUsersDeleteAdminUsersIdGuidSessions200>(
    { url: `/admin/users/${id}/sessions`, method: 'DELETE' },
    options,
  );
};

export const getAdminUsersDeleteAdminUsersIdGuidSessionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuidSessions>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuidSessions>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminUsersDeleteAdminUsersIdGuidSessions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuidSessions>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminUsersDeleteAdminUsersIdGuidSessions(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersDeleteAdminUsersIdGuidSessionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuidSessions>>
>;

export type AdminUsersDeleteAdminUsersIdGuidSessionsMutationError = unknown;

export const useAdminUsersDeleteAdminUsersIdGuidSessions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuidSessions>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersDeleteAdminUsersIdGuidSessions>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminUsersDeleteAdminUsersIdGuidSessionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
